import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-109">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" onClick={onClose} aria-hidden="true" data-id="element-110" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-111">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col pointer-events-auto" role="dialog" aria-modal="true" aria-labelledby="modal-title" onClick={e => e.stopPropagation()} data-id="element-112">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-113">
                <h2 id="modal-title" className="text-2xl md:text-3xl font-bold text-emerald-primary" data-id="element-114">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar modal" data-id="element-115">
                  <XIcon className="w-6 h-6 text-gray-600" data-id="element-116" />
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto p-6 flex-1" data-id="element-117">{children}</div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}